module.exports = __webpack_public_path__ + "static/media/pin.f50bc6ba.png";